import { MembershipWithOrganizationTypeEnum } from '@/api/rest/resources/types/membership';
import { paths } from '@/routing';

import { useMembershipType } from './useMembershipType';

export const useAccountPageRoutes = () => {
  const membershipType = useMembershipType();

  if (membershipType === MembershipWithOrganizationTypeEnum.buyer) {
    return {
      accountPath: paths.buyer.account,
      accountEditEmailPath: paths.buyer.accountEditEmail,
      accountEditNamePath: paths.buyer.accountEditName,
      accountEditPasswordPath: paths.buyer.accountEditPassword,
      accountLegalPath: paths.buyer.accountLegal,
      accountTeamPath: paths.buyer.accountTeam,
      accountTeamInvitePath: paths.buyer.accountTeamInvite,
      accountTeamEditMemberPath: paths.buyer.accountTeamEditMember,
      restrictedAccess: paths.buyer.restrictedAccess,
    };
  }
  if (membershipType === MembershipWithOrganizationTypeEnum.land_steward) {
    return {
      accountPath: paths.landSteward.account,
      accountEditEmailPath: paths.landSteward.accountEditEmail,
      accountEditNamePath: paths.landSteward.accountEditName,
      accountEditPasswordPath: paths.landSteward.accountEditPassword,
      accountLegalPath: paths.landSteward.accountLegal,
      accountTeamPath: paths.landSteward.accountTeam,
      accountTeamInvitePath: paths.landSteward.accountTeamInvite,
      accountTeamEditMemberPath: paths.landSteward.accountTeamEditMember,
      restrictedAccess: paths.landSteward.restrictedAccess,
    };
  }
  return {
    accountPath: paths.staff.account,
    accountEditEmailPath: paths.staff.accountEditEmail,
    accountEditNamePath: paths.staff.accountEditName,
    accountEditPasswordPath: paths.staff.accountEditPassword,
    accountLegalPath: paths.staff.accountLegal,
    accountTeamPath: paths.staff.accountTeam,
    accountTeamInvitePath: paths.staff.accountTeamInvite,
    accountTeamEditMemberPath: paths.staff.accountTeamEditMember,
    restrictedAccess: paths.staff.restrictedAccess,
  };
};
